// No more than maxConsecutive working days in any sliding window
// Uses day-work indicators w_{u,day}.
// Params: { maxConsecutive: number } default 6
export function buildMediaConsecutiveDaysConstraints(model, params = {}) {
  const idx = model?.optimizationIndexes || {};
  const users = Object.keys(idx.users || {});
  const dayKeys = Array.isArray(idx.dayKeys) ? idx.dayKeys.slice() : [];
  const wDeclared = new Set(Object.keys(idx.dayWorkDecisionVariables || {}));
  const maxConsec = Number(params?.maxConsecutive) > 0 ? Number(params.maxConsecutive) : 6;
  const window = maxConsec + 1;
  if (!dayKeys.length || !users.length || window <= 1) return [];

  const constraints = [];
  for (let i = 0; i + window - 1 < dayKeys.length; i++) {
    const windowDays = dayKeys.slice(i, i + window);
    for (const uKey of users) {
      const vars = [];
      for (const d of windowDays) {
        const wName = `w_${uKey}_${d}`;
        if (wDeclared.has(wName)) vars.push(wName);
      }
      if (!vars.length) continue;
      const coeffs = vars.map(() => 1);
      // sum w <= maxConsec
      constraints.push({ linear: { vars, coeffs }, domain: [-100000, maxConsec] });
    }
  }
  return constraints;
}

